import { toggleAllInputsInContainer } from './toggleInputsInContainer';

export const inputOtherListener = () => {
    const inputOtherElements = [...document.querySelectorAll('.js-input-other')];

    const listenerElements = inputOtherElements
        .reduce((acc, el) => [...acc, ...[...document.querySelectorAll(`[name="${el.name}"]`)]], [])
        .filter((el) => !el.dataset.inputOtherInitialized);

    listenerElements.forEach((el) => {
        const elementsToShow = document.querySelectorAll(`[data-input-other-name="${el.name}"]`);

        el.addEventListener('change', (e) => {
            if (e.target.classList.contains('js-show-input-other')) {
                elementsToShow?.forEach((container) => {
                    container.classList.remove('d-none');
                    toggleAllInputsInContainer(container, true);
                });
            } else {
                elementsToShow?.forEach((container) => {
                    container.classList.add('d-none');
                    toggleAllInputsInContainer(container, false);
                });
            }
        });
        el.dataset.inputOtherInitialized = true;
    });
};
